// src/data/history.data.ts

export type HistoryType = '구축' | '고도화' | '운영' | '컨설팅' | '개발';

export type TimelineItem = {
  month: string; // '01' ~ '12'
  content: string;
  type?: HistoryType;
};

export type TimelineYear = {
  year: number;
  items: TimelineItem[];
};

export const TIMELINE_DATA: TimelineYear[] = [
  {
    year: 2026,
    items: [
      { month: '02', content: '현대 중국북경법인 APS3.0 고도화 프로젝트 수의계약', type: '고도화' },
      { month: '02', content: '기아 멕시코법인 26년도 GASC 운영 및 유지보수', type: '운영' },
      { month: '02', content: '26년도 전문대학 진로진학 통합상담시스템 고도화 및 유지관리', type: '고도화' },

      { month: '01', content: '현대기아차 해외 4개법인 GASC 26년도 운영 유지보수', type: '운영' },
      { month: '01', content: '기아 렌터카 대국민 서비스 26년도 운영 및 유지보수', type: '운영' },
      { month: '01', content: '지역난방기술 26년도 설계협업시스템(KEMS) 유지보수', type: '운영' },
      { month: '01', content: 'DB하이텍 어댑터 S/W 26년도 유지보수', type: '운영' },
    ],
  },
  {
    year: 2025,
    items: [
      { month: '12', content: '현대차 GSPS 시스템 고도화', type: '고도화' },
      { month: '12', content: 'PDF OCR 통합처리 패키지 개발', type: '개발' },

      { month: '11', content: '기아 멕시코법인 GASC 추가 기능(통합결재-대결) 개선', type: '고도화' },

      { month: '10', content: '벨더바이오 동작분석 AI 프로그램 납품', type: '개발' },
      { month: '10', content: 'PyMuPDF 및 TextSence 통합문서처리 패키지 납품', type: '개발' },

      { month: '08', content: '벨더스포츠 솔루션 데이터 플랫폼 & 서버 납품', type: '개발' },
      { month: '08', content: '인천국제공항 시설물관리시스템 구축', type: '구축' },
      { month: '08', content: '국가보훈부 페이퍼리스 운영서비스 고도화', type: '고도화' },

      { month: '07', content: '현대차 해외 3개법인 APS 운영 및 유지보수 수의계약', type: '운영' },

      { month: '06', content: '현대기아 판매생산최적화(APS3.0) 시스템 구축', type: '구축' },

      { month: '05', content: '국가보훈부 통합보훈정보시스템 성능개선 컨설팅', type: '컨설팅' },

      { month: '04', content: '기아 멕시코법인 2025년도 GASC 운영 및 유지보수', type: '운영' },
      { month: '04', content: '현대오토에버 취약점 통합 관리 시스템 고도화', type: '고도화' },

      { month: '02', content: '기아 2025년도 렌터카 대국민 서비스 운영 및 유지보수', type: '운영' },

      { month: '01', content: '국가보훈부 디지털창구 시스템 구축', type: '구축' },
      { month: '01', content: '2025년도 전문대학 진로진학 통합상담시스템 고도화 및 유지관리', type: '고도화' },
      { month: '01', content: '지역난방기술 / 25년도 설계협업시스템(KEMS) 유지보수', type: '운영' },
    ],
  },
  {
    year: 2024,
    items: [
      { month: '10', content: '(주)크리스피드 NIPA 차세대 정보시스템 구축 프로그램 테스트', type: '구축' },
      { month: '08', content: '한국가스기술공사 3D 모델 활용 시스템 개발 용역', type: '개발' },
      { month: '05', content: '유안타증권 전자문서 솔루션 추가 기능 개발', type: '개발' },
      { month: '03', content: '국립부산과학관 홈페이지 유지보수 및 디자인 개선', type: '운영' },
      { month: '03', content: '현대오토에버 MEXICO 총무시스템 유지보수', type: '운영' },
      { month: '03', content: 'SK실리콘스 Paperless System 유지보수', type: '운영' },
      { month: '01', content: 'KIA 기아렌터카 시스템 운영', type: '운영' },
      { month: '01', content: 'SK마이크로웍스 IT 시스템 유지보수', type: '운영' },
      { month: '01', content: '현대오토에버 판매생산최적화(APSI) 시스템 개발', type: '개발' },
      { month: '01', content: '한국지역난방기술 설계협업 시스템(KEMS) 유지보수', type: '운영' },
    ],
  },
  {
    year: 2023,
    items: [
      { month: '12', content: '전국화물자동차공제조합 이미지시스템 고도화 사업 수행', type: '고도화' },
      { month: '01', content: '현대오토에버 취약점이력관리시스템 유지보수 수행', type: '운영' },
      { month: '01', content: 'KIA 기아렌터카 서비스 신규 기능 개발', type: '개발' },
    ],
  },
  {
    year: 2022,
    items: [
      { month: '12', content: '경기신용보증재단 비대면 플랫폼 연계(ESB) 표준 개발', type: '개발' },
      { month: '12', content: '포스코ICT 포스코 EP 통합검색 직무학습포털 운영', type: '운영' },

      { month: '11', content: 'SK실리콘스 페이퍼리스 멀티뷰어 추가 기능 개발', type: '개발' },
      { month: '11', content: '윙브릿지 아나바다 물물교환 이커머스 플랫폼 통합유지보수', type: '운영' },
      { month: '11', content: '엠바스 서울대 도서관 Android Application 개발', type: '개발' },

      { month: '10', content: '경기신용보증재단 비대면 플랫폼 구축 개발', type: '구축' },
      { month: '10', content: '현대트랜시스 동반성장포탈 웹접근성 적용 및 업무개선 개발', type: '고도화' },

      { month: '08', content: 'CVnet 스마트주차장솔루션 서비스 기획 및 서비스 개발', type: '개발' },
      { month: '08', content: '현대트랜시스 동반성장포탈 웹접근성 적용 및 업무개선 개발', type: '고도화' },

      { month: '07', content: '한국수산기술연구원 머신러닝 기반 수산 양식 생산성 예측 및 향상을 위한 자동 분석 시스템 개발', type: '개발' },

      { month: '06', content: 'CVnet 스마트주차장솔루션 서비스 기획 및 DB 설계', type: '컨설팅' },

      { month: '05', content: 'CJ대한통운 차세대 택배시스템 구축', type: '구축' },

      { month: '04', content: '포스코 직무학습 포털 AI 기반 콘텐츠 검색 및 추천 기능 개발', type: '개발' },
      { month: '04', content: 'CVnet 스마트티머리 임베디드 앱 및 연동 모바일 앱 개발', type: '개발' },
      { month: '04', content: '웰컴저축은행 페이퍼리스 구축', type: '구축' },
      { month: '04', content: 'SK이노베이션 Phase 2 모바일 설비작업관리 및 고도화 구축', type: '구축' },
      { month: '04', content: '유안타증권 지점창구 전자문서 솔루션 개발', type: '개발' },

      { month: '01', content: 'SKC PAD 시스템 운영 및 유지보수', type: '운영' },
      { month: '01', content: 'KB헬스케어 디지털헬스케어 플랫폼 구축 개발', type: '구축' },
      { month: '01', content: '현대오토에버 취약점이력관리시스템 유지보수', type: '운영' },
    ],
  },
  {
    year: 2021,
    items: [
      { month: '10', content: 'SSG.com 물류센터 SW 플랫폼 구축 수주', type: '구축' },
      { month: '10', content: '한국도로공사 프로젝트 관리 및 설계협업 시스템 기능개선 개발', type: '고도화' },
      { month: '10', content: '한국시각장애인생활이동지원센터 관제시스템 유지보수 수주', type: '운영' },

      { month: '07', content: '한국지역난방기술 프로젝트 관리 및 설계협업 시스템 기능개선 개발', type: '고도화' },

      { month: '05', content: '2021 WCG 홈페이지/App 신규 구축 및 유지운영', type: '구축' },
      { month: '05', content: 'GASC Business Card Project', type: '개발' },

      { month: '04', content: '슈퍼셀 e스포츠 플랫폼 구축', type: '구축' },
      { month: '04', content: '마이데이터 표준 API 제공 시스템 구축', type: '구축' },

      { month: '03', content: 'KB카드 마이데이터 표준API 제공 시스템 구축', type: '구축' },
      { month: '03', content: 'KB카드 마이데이터 수집용 포털 시스템 구축', type: '구축' },

      { month: '02', content: 'WCG 홈페이지/App 운영 및 유지보수', type: '운영' },

      { month: '01', content: '현대오토에버 통합자재 구매 시스템 개편 개발', type: '개발' },
      { month: '01', content: '한국과학기술기획평가원 연구지원시스템 통합 구축 사업', type: '구축' },
      { month: '01', content: '한화생명 업무공유시스템(금융계열사) 구축', type: '구축' },
      { month: '01', content: 'SKC PAD 시스템 및 솔루션 유지보수', type: '운영' },
    ],
  },
  {
    year: 2020,
    items: [
      { month: '12', content: '국립생태원 D-센터럴 구축', type: '구축' },

      { month: '11', content: '볼보자동차코리아 전자문서 시스템 고도화', type: '고도화' },
      { month: '11', content: 'SKC PAD 시스템 개발', type: '개발' },
      { month: '11', content: '하나캐피탈 eForm 개발', type: '개발' },
      { month: '11', content: '한컴인텔리전스 Tracer 모듈 개발', type: '개발' },
      { month: '11', content: '지하철9호선 공기청정기 관리서비스 개발', type: '개발' },
      { month: '11', content: '한컴 MDS Trace32 서비스 개발', type: '개발' },

      { month: '10', content: '한컴로보틱스 홈로봇 SW 플랫폼 개발', type: '개발' },
      { month: '10', content: '한국씨티은행 Teller Operation Paperless 개발', type: '개발' },
      { month: '10', content: '고양시 호수페스티벌 홈페이지 제작', type: '개발' },

      { month: '09', content: 'KIA MOTORS MEXICO 총무지원시스템 구축', type: '구축' },
      { month: '09', content: 'KESCo 차세대 경영정보 일반용안전점검 시스템 구축', type: '구축' },
      { month: '09', content: '하나금융TI Digital HR 시스템 구축 (OZ 서식개발)', type: '구축' },
      { month: '09', content: '한화생명 업무공유시스템(협업/정보공유) 구축', type: '구축' },
      { month: '09', content: '한화솔루션/큐셀 그룹웨어 구축', type: '구축' },

      { month: '06', content: '한국타이어 스마트세일즈 고도화 사업', type: '고도화' },
      { month: '06', content: '보건복지부 국립병원 EMR e-Form 개발', type: '개발' },
      { month: '06', content: 'SKC Paperless 시스템 확산', type: '고도화' },
      { month: '06', content: '헬스마이닝 어드민 개발', type: '개발' },

      { month: '05', content: 'KB증권 WS영업지원시스템 구축', type: '구축' },
      { month: '05', content: '365mc 홈페이지 퍼블리싱', type: '개발' },
      { month: '05', content: 'SKC 투명PI RFID 및 Paperless 유지보수', type: '운영' },
      { month: '05', content: '국방기술품질원 정보시스템 고도화 사업', type: '고도화' },
      { month: '05', content: 'KISTE 연구지원시스템 통합 구축 사업', type: '구축' },

      { month: '04', content: 'WCG 홈페이지/App 신규 구축 및 운영', type: '구축' },
      { month: '04', content: '법무법인 감명 홈페이지 통합 구축', type: '개발' },
      { month: '04', content: '신세계그룹 인사시스템 서식개발', type: '개발' },
      { month: '04', content: 'Wassup 관리자 웹 퍼블리싱', type: '개발' },

      { month: '03', content: '현대모비스 AS부품 통합시스템 인프라 구축 개발', type: '구축' },
      { month: '03', content: '전국개인택시운송사업조합연합회 시스템 개발', type: '개발' },
      { month: '03', content: 'BLUEMAX Client v2.0 기능 개발', type: '개발' },

      { month: '02', content: '미래에셋대우 계좌업무 기능 개발', type: '개발' },
      { month: '02', content: '(주)메디톡스코리아 모바일 SFA 구축 개발', type: '개발' },
      { month: '02', content: '미래에셋 SageClub 모바일 구축 개발', type: '개발' },

      { month: '01', content: '토요타코리아 전자계약 시스템 개발', type: '개발' },
      { month: '01', content: '차세대 무선 표준 802.11ax 지원 무선침입방지시스템 기능 개발', type: '개발' },
      { month: '01', content: '삼성생명보험 보험거래디지털화 구축 개발', type: '구축' },
      { month: '01', content: '부영 ERP 공사관리시스템 구축 개발', type: '구축' },
    ],
  },
  {
    year: 2019,
    items: [
      { month: '12', content: '씨앤피시스템 ERP 서비스 구축', type: '구축' },

      { month: '11', content: 'KT GIGAsafe SOC 서비스 기능 개선 및 고도화', type: '고도화' },
      { month: '11', content: 'B네트웍스 쇼핑몰 운영 유지보수', type: '운영' },
      { month: '11', content: 'SKC 19년도 투명PI RFID 및 Paperless 구축', type: '구축' },
      { month: '11', content: 'HKMC 비즈니스지원 디지털 플랫폼 구축', type: '구축' },
      { month: '11', content: 'DoosanCONNECT 신규 Platform 구축', type: '구축' },

      { month: '10', content: '한국과학기술원 IAM 서비스 구축사업 지원', type: '컨설팅' },
      { month: '10', content: '부영 ERP 공사관리시스템 개발', type: '개발' },

      { month: '09', content: '현대자동차 스마트점검 모바일 자재관리 통합 개발', type: '개발' },

      { month: '08', content: '기아자동차 모바일 통합앱 유지보수', type: '운영' },
      { month: '08', content: 'KB국민은행 디지털창구 서식관리시스템 고도화', type: '고도화' },
      { month: '08', content: 'LG화학 외국환 신고 관리 프로젝트 구축', type: '구축' },
      { month: '08', content: '우원개발 ERP 고도화 개발', type: '고도화' },
      { month: '08', content: 'BNK경남은행 창구전자문서 업무확대 및 고도화', type: '고도화' },
      { month: '08', content: '미래에셋대우 계좌업무 기능 개발', type: '개발' },

      { month: '07', content: 'KEB하나은행 글로벌차세대 시스템 구축 지원', type: '구축' },
      { month: '07', content: '현대산업개발 공사관리구축 개발', type: '구축' },
      { month: '07', content: '메가박스 차세대 통합영업시스템 구축', type: '구축' },
      { month: '07', content: '캐롯손해보험 API 포털 디자인', type: '컨설팅' },

      { month: '06', content: '토요타코리아 전자계약 시스템 구축', type: '구축' },

      { month: '04', content: '애큐온 저축은행 페이퍼리스 시스템 구축', type: '구축' },

      { month: '03', content: '하나금융투자 디지털창구 페이퍼리스 개발', type: '개발' },

      { month: '01', content: '회사 설립', type: '컨설팅' },
      { month: '01', content: '두산 인프라코어 Doosan CONNECT 모바일 APP 유지보수', type: '운영' },
    ],
  },
];